import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { QuillLogo } from "./QuillLogo";

// Shared admin header with section navigation and sign-out.
export const AdminNav = ({ active, right = null }) => {
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem("rq_admin_token");
    navigate("/admin");
  };
  const link = (to, id, label) => (
    <Link
      to={to}
      data-testid={`admin-nav-${id}`}
      className={`text-[11px] uppercase tracking-[0.28em] transition-colors ${
        active === id ? "text-[#7A2E2E]" : "text-[#1C1A17] hover:text-[#7A2E2E]"
      }`}
    >
      {label}
    </Link>
  );

  return (
    <header className="border-b" style={{ borderColor: "rgba(168,162,150,0.5)" }}>
      <div className="mx-auto max-w-[900px] px-6 md:px-8 py-6 flex items-center justify-between gap-6">
        <div className="flex items-center gap-4">
          <QuillLogo height={36} />
          <span className="hidden sm:inline text-[11px] uppercase tracking-[0.3em] text-[#7A2E2E]">
            The Archive
          </span>
        </div>
        <div className="flex items-center gap-5 md:gap-7">
          {link("/admin/enquiries", "enquiries", "Enquiries")}
          {link("/admin/studio", "studio", "Studio Kit")}
          {link("/admin/documents", "documents", "Documents")}
          {link("/admin/signatures", "signatures", "Signatures")}
          {link("/admin/book", "book", "Book")}
          <Link
            to="/"
            data-testid="admin-nav-view-site"
            className="text-[11px] uppercase tracking-[0.28em] text-[#1C1A17] hover:text-[#7A2E2E] transition-colors"
          >
            View Site
          </Link>
          {right}
          <button
            onClick={logout}
            className="text-[11px] uppercase tracking-[0.28em] text-[#1C1A17] hover:text-[#7A2E2E] transition-colors"
            data-testid="admin-logout"
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
};
